<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full h-auto max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0 pr-1">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>

        <div v-if="metadata === null" class="w-full h-auto max-h-full overflow-auto px-4">
          <span class="text-lg font-bold tracking-wider">{{metadaLabelInfo}}</span>
        </div>

        <div v-else class="w-full h-auto max-h-full overflow-auto px-4">
          <div class="flex w-full bg-cdmx-green text-white font-semibold uppercase tracking-wider">
            <div class="w-1/2 border-2">Etiqueta</div>
            <div class="w-1/2 border-2 border-l-0">Valor</div>
          </div>
          <div class="flex w-full" v-for="(data, key) in metadata" :key="key">
            <div class="w-1/2 border-2 border-t-0 text-left px-4 font-bold">{{key}}</div>
            <div class="w-1/2 border-2 border-t-0 border-l-0 text-left px-4">{{data}}</div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import axios from "axios";
import moment from "moment";

export default {
  name: "metadata-modal",
  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    metadata: {
      required: true
    },
    filetype: {
      required: true
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  computed: {
    metadaLabelInfo() {
      switch (this.filetype) {
        case "image/jpeg":
          return "Metadatos de imagen no disponible";
          break;
        case "video/mp4":
          return "Metadatos de video no disponible";
          break;
        default:
          return "Metadatos de media no disponible";
          break;
      }
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>